module.exports = __webpack_public_path__ + "img/Plan2.5347b0a9.png";